import React from "react";
import { Tabs } from "@ann/web-components";
import { TabsContainer } from "./Tabs.styled";
import { KnowledgeHubTabsEnum } from "../../enums/knowledgeHubTabs";

const KnowledgeHubTabs = ({ onTabChange, defaultIndex = KnowledgeHubTabsEnum.OVERVIEW }) => {
  const handleTabChange = (index) => {
    if (onTabChange) {
      onTabChange(index);
    }
  };

  return (
    <TabsContainer>
      <Tabs defaultIndex={defaultIndex} size="medium" onChange={handleTabChange}>
        <Tabs.List>
          <Tabs.Tab  index={KnowledgeHubTabsEnum.OVERVIEW}>
            Overview
          </Tabs.Tab>
          <Tabs.Tab  index={KnowledgeHubTabsEnum.FACTS}>
            Facts
          </Tabs.Tab>
          <Tabs.Tab index={KnowledgeHubTabsEnum.TRAIN_PROGRESS}>
            Train Progress
          </Tabs.Tab>
          <Tabs.Tab index={KnowledgeHubTabsEnum.USERS}>
            Users
          </Tabs.Tab>
          <Tabs.Tab index={KnowledgeHubTabsEnum.SUGGESTIONS}>
            Suggestions
          </Tabs.Tab>
          <Tabs.Tab index={KnowledgeHubTabsEnum.ACTIVITY_LOG}>
            Activity Log
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>
    </TabsContainer>
  );
};

export default KnowledgeHubTabs;

